import { useUserStore } from '@/stores/index.js';
import i18n from '@/locale/index.js';

// 提示框
export const toast = (title, options = {}) => {
    return new Promise((resolve, reject) => {
        //默认配置
        let config = {
            icon: 'none',
            image: '',
            mask: true,
            duration: 1500
        };
        //对象合并 新旧配置合并
        Object.assign(config, options);

        uni.showToast({
            title: String(title),
            ...config
        }).then(() => {
            setTimeout(resolve, config.duration);
        });
    });
};

//防抖
export function debounce(func, timeout = 300) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

//节流
export function throttle(fn, mustDelay = 300) {
    let timer,
        start = 0;
    return function (...args) {
        let now = new Date().getTime();
        if (now > start + mustDelay) {
            fn.apply(this, args);
            start = now;
        }
    };
}

// 首页路径
export const HOME_PAGE = '/pages/tabbar/home/index';

// 统一补全前导斜杠，便于和 HOME_PAGE 比较
const normalizePath = (url = '') => {
    const path = String(url).split('?')[0];
    return path.startsWith('/') ? path : `/${path}`;
};

// 页面不存在类错误，各端 errMsg 文案略有差异
const PAGE_NOT_FOUND_RE = /not\s*found|not\s*registered|页面不存在/i;

// 路由异常兜底：目标页面不存在时回首页
export const onRouteFail = (err, url = '') => {
    const errMsg = err?.errMsg || err?.message || '';
    console.error('[router] 跳转失败', url, errMsg || err);
    // 其他失败（如页面栈超限、navigateTo 跳 tabBar）保持原行为，不弹回首页
    if (!PAGE_NOT_FOUND_RE.test(errMsg)) return;
    // 首页自身跳转失败不再重试，避免死循环
    if (normalizePath(url) === HOME_PAGE) return;
    uni.reLaunch({ url: HOME_PAGE });
};

//路由
export const router = debounce((options = {}) => {
    if (typeof options === 'string') {
        uni.navigateTo({
            url: options
        });
    } else {
        const { url, delta } = options;
        switch (options.type) {
            case 'navigateTo':
                uni.navigateTo({
                    url
                });
                break;
            case 'redirectTo':
                uni.redirectTo({
                    url
                });
                break;
            case 'reLaunch':
                uni.reLaunch({
                    url
                });
                break;
            case 'switchTab':
                uni.switchTab({
                    url
                });
                break;
            case 'navigateBack':
                uni.navigateBack({
                    delta
                });
                break;
            default:
        }
    }
}, 300);

export function getUrlParams(variable, query) {
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return false;
}

// 数字单位
export function formatNumberUnit(number) {
    const SI_POSTFIXES = ['', 'k', 'M', 'B', 'T'];
    const tier = (Math.log10(Math.abs(number)) / 3) | 0;
    if (tier == 0) return number;
    const suffix = SI_POSTFIXES[tier];
    const scale = Math.pow(10, tier * 3);
    const scaled = number / scale;
    return scaled.toFixed(1) + suffix;
}

// 保留小数位
export function fixedNumber(val, len = 2) {
    const num = Number(val);
    if (isNaN(num)) return val;
    return num.toFixed(len);
    //.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// 保留小数位 不四舍五入
export function truncateNumber(number, digits) {
    const multiplier = Math.pow(10, digits);
    return Math.trunc(number * multiplier) / multiplier;
}

// 修改数据格式
export function formatModificationNumber(val, len = 0) {
    val = fixedNumber(val, len);
    if (!val) return 0;
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
// 修改金额对应市场
export function formatAmountToMarket(val, market) {
    return formatAmount(val, marketToLength(market));
}

//  修改金额
export function formatAmount(val, len = 2) {
    val = fixedNumber(val, len);
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function marketToLength(market) {
    switch (market) {
        case 'TSE':
            return 1;
        case 'KSE':
            return 0;
        default:
            return 3;
    }
}

// 国家货币
export function onCountryCurrency(currency) {
    switch (currency) {
        case 'JPY':
            return '円';
        default:
            return currency;
    }
}

// 跳转客服
export function onCustomerService(cUrl = '', title = '') {
    const { t } = i18n.global;
    const userStore = useUserStore();
    const { email, phone, id, userName, customerServiceUrl } = userStore.userInfo;
    let url = cUrl || customerServiceUrl;
    if (!url) return;
    const params = {
        '[email]': email,
        '[phone]': phone,
        '[uid]': id,
        '[name]': userName
    };
    console.log(params);
    Object.keys(params).forEach((key) => {
        url = url.replace(key, params[key]);
    });
    // #ifdef H5
    // 判断如果有这个参数就跳转外部浏览器 不走webview
    if (url.includes('jump=1')) {
        window.location.href = url;
        return;
    }

    uni.navigateTo({
        url: `/pages/webview/index?url=${encodeURIComponent(url)}&title=${title || t('common.service')}`
    });
    // #endif

    // #ifdef APP-PLUS
    plus.webview.open(url);
    // #endif
}

// 新增一个方法，替换指定文本为另外一个文本，如果有才替换
export function replaceText(text, oldText, newText) {
    if (text && text.includes(oldText)) {
        return text.replace(oldText, newText);
    }
    return text;
}
